(ns bec-cljs-common.components.player
  (:require [reagent.core :as r]
            [re-frame.core :as rf]
            [bec-cljs-common.config :as bcc.config]
            [bec-cljs-common.components.image :refer [img]]
            [bec-cljs-common.re-frame :as bec-rf]))

(defn circle-styles [diameter color margin]
  {:display "flex"
   :flex-direction "column"
   :align-items "center"
   :justify-content "center"
   :border-radius "50%"
   :height diameter
   :width diameter
   :background-color color
   :box-shadow (str "0 0 calc(" diameter " / 2.5) 0 var(--scheme-main)")
   :margin (if (nil? margin)
             "0 1.5vmin"
             margin)})

(defn inner-styles [diameter]
  {"--border-size"   (str "calc(" diameter " / 7)")
   "--size"          (str "calc(" diameter " - var(--border-size))")
   :width            "var(--size)"
   :height           "var(--size)"
   :object-fit "cover"
   :border-radius    "50%"
   :display          "flex"
   :flex-direction   "row"
   :justify-content  "center"
   :align-items      "center"
   :box-shadow       "inset 0 0 calc(var(--size) / 2.6) #000"
   :background-size  "cover"
   :margin "0"})

(defn pompom [props]
  (let [player-color (or (:player-color props) (:color (:player props)))
        dark-color @(rf/subscribe [:rgb-color-dark player-color])
        color @(rf/subscribe [:rgb-color player-color])
        size (or (:size props) "1rem")]
    [:div
     (merge
       {:style (merge
                 {:position "absolute"
                  :bottom "0.2rem"
                  :z-index "1"
                  :pointer-events "none"}
                 (:style props))}
       (dissoc props :player :player-color :style :size))
     (into
       [:div
        {:style {:position "relative"
                 :display "flex"
                 :justify-content "center"
                 :align-items "center"
                 :width (str "calc(" size "* 2)")
                 :height (str "calc(" size "* 2)")
                 :animation "bounce 2s cubic-bezier(.5,0.05,1,.5) infinite"}}
        [:div
         {:style {:width size
                  :height size
                  :margin-top size
                  :border-radius "50%"
                  :background "var(--scheme-main)"}}]]
       (for [x (range 12)]
         [:div
          {:key x
           :style {:position "absolute"
                   :transform-origin "bottom"
                   :transform (str "rotate(" (* x 30) "deg)")
                   :height size
                   :width size
                   :clip-path "polygon(25% 0, 25% 100%, 75% 0)"
                   :background (if (even? x) color dark-color)
                   "--change-background-color-1" (if (even? x) color dark-color)
                   "--change-background-color-2" (if (odd? x) color dark-color)
                   :animation "change-background-color 0.5s infinite ease"}}]))]))

(defn player-circle [{:keys [id player size color player-color margin key class style outer-style with-pompoms?
                             on-click on-drag on-drag-start on-drag-end draggable themed-photo? img-style]}]
  (let [full-size (or size "5.5rem")
        id (or id (:id player))
        color (or color @(rf/subscribe [:rgb-color (:color player)]) "var(--primary-brand-color)") 
        outer-styles (circle-styles
                       full-size
                       color
                       margin)
        inner-style (inner-styles
                      full-size)]
    [(if on-click :button.player-circle :div.player-circle)
     {:key key
      :class (str class (when on-click " is-clickable "))
      :style outer-style
      :draggable draggable
      :on-drag on-drag
      :on-drag-end on-drag-end
      :on-drag-start on-drag-start
      :on-click on-click}
     [:div
      {:style (merge outer-styles {:pointer-events "none"} style)}
      (when with-pompoms?
        [pompom
         {:player player
          :player-color player-color
          :size (str "calc(" full-size "* 0.2)")
          :style {:margin-right (str "calc(" full-size "* 0.5)")}}])
      (when with-pompoms?
        [pompom
         {:player player
          :player-color player-color
          :size (str "calc(" full-size "* 0.2)")
          :style {:margin-left (str "calc(" full-size "* 0.5)")}}])
      [:div {:style inner-style}
       (when id
         [img
          {:id (str "player-circle-img-" id)
           :style (dissoc (merge inner-style img-style) :box-shadow)
           :draggable (not draggable)
           :src (bec-rf/url-cache-bust
                  (str bcc.config/app-server-url "/public/player_photos/" id
                    (if (false? themed-photo?) ".png" "_themed.png")))}])]]]))

(defn player-card [props]
  (let [player (:player props)
        color (:color props)
        color (or color @(rf/subscribe [:rgb-color (:color player)]) "var(--primary-brand-color)")
        color-dark (or (:color-dark props) @(rf/subscribe [:rgb-color-dark (:color player)]) "var(--primary-brand-color-dark)")
        size (or (:size props) "5rem")]
    [:div
     {:style (merge
               {:position "relative"
                :margin "0.5rem"
                :border-bottom-right-radius (when (:is-draggable? props) "0.15rem")
                :overflow "hidden"}
               (dissoc (:style props) :filter :custom-text))}
     (into
       [:div
        {:style {:display "flex"
                 :justify-content "space-between"
                 :align-items "center"
                 :flex-direction "column"
                 :background color-dark
                 :border-radius "0.5rem"
                 :height (:height (:style props))
                 :width (:width (:style props))}}
        [player-circle
         {:color color
          :player player
          :with-pompoms? (:with-pompoms? props)
          :size size
          :themed-photo? (:themed-photo? props)
          :img-style {:filter (:filter (:style props))}
          :style {:display "flex"
                  :justify-content "center"
                  :align-items "center"
                  :margin (or (:margin (:style props)) "0.5rem")}

          :on-click (:on-click props)}]
        [:p.subtitle.text-overflow
         {:style {:margin (or (:nick-margin props) "0 0.25rem 0.5rem")
                  :font-size (or (:font-size (:style props)) (str "calc(" size " / 4)"))

                  :color "var(--scheme-main)"
                  :text-align (:text-align (:style props))
                  :max-width (or (:nick-max-width props) (str "calc(" size " + 0.5rem)"))
                  :width (:nick-width props)}}
         (or (:custom-text props) (:nick (:player props)) "N/A")]
        (when (:is-draggable? props)
          [:div
           {:style {:position "absolute"
                    :width (str "calc(" size " / 4)")
                    :height (str "calc(" size " / 4)")
                    :bottom "0"
                    :right "0"
                    :clip-path "polygon(100% 0, 0% 100%, 100% 100%)"
                    :background "var(--primary-brand-color)"}}])]
       (r/children (r/current-component)))]))

(def video-player-select-end (r/atom 0))

(defn player-selection [props]
  (let [player (:player props)
        id (or (:id props) (str "player-selection-" (:id player)))]
    [:div
     {:class "fade-in"
      :style {:display "flex"
              :justify-content "center"
              :align-items "center"
              :height "100%"
              :max-height "50vh"
              :max-width "75%"
              :min-width "50vw"}}
     (when (= @video-player-select-end 1)
       [player-circle
        {:player player
         :size "25vmin"
         :outer-style {:display "flex"
                       :justify-content "center"
                       :align-items "center"}
         :style {:position "absolute"
                 :animation "scale-rotate-fade-in 500ms 0ms ease-in both, pulsate-fwd 1000ms 550ms ease-in-out forwards infinite"}
         :key id}])
     [:video
      {:key "player-selection-video"
       :id id
       :auto-play (if (false? (:auto-play props))
                    false
                    true)
       :muted true
       :loop false
       :on-can-play (fn []
                      (reset! video-player-select-end 0)
                      (.play (js/document.getElementById id)))
       :on-ended (fn []
                   (reset! video-player-select-end 1))
       :style {:position "absolute"
               :height "100vh"
               :opacity (when (= 1 @video-player-select-end) 0)
               :max-height "100vw"
               :max-width "55rem"
               :min-width "50vw"}}
      [:source
       {:src "images/darts/wof/tut2.webm"
        :type "video/webm"}]]]))
